import React, { useRef, useEffect } from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ProductImage from './ProductImage';

function ProductSlider({
  slideList,
  currentSlideIdx,
  itemClick,
  btnColor,
  fontColor,
  font,
  setSlider,
  syncSlider,
  type,
  isHorizontal = false,
  isMobile = false,
}) {
  const sliderRef = useRef();

  useEffect(() => {
    setSlider(sliderRef.current);
  }, []);

  const sliderSettings = {
    dots: false,
    infinite: false,
    arrows: false,
    speed: 700,
    swipeToSlide: true,
    slidesToShow: slideList.length > 3 ? 3 : slideList.length,
    slidesToScroll: 1,
    variableWidth: true,
  };

  return (
    <SliderContainer isHorizontal={isHorizontal} isMobile={isMobile}>
      <Slider {...sliderSettings} ref={sliderRef} asNavFor={syncSlider}>
        {slideList.map((slide, idx) => (
          <ProductImage
            key={slide.slideNo}
            itemImg={slide.itemImage}
            imgIdx={idx}
            nowIdx={currentSlideIdx}
            itemClick={itemClick}
            color={btnColor}
            fontColor={fontColor}
            fontFamily={font}
            previewType={type}
          />
        ))}
      </Slider>
    </SliderContainer>
  );
}

export default ProductSlider;

const SliderContainer = styled.div`
  width: ${(props) => (props.isHorizontal ? '50%' : '100%')};
  height: 100%;
  display: flex;
  align-items: center;

  div {
    width: 100%;
    height: 100%;
  }

  .slick-slider {
    height: 85%;

    & > .slick-list {
      padding-left: 10px;

      & > .slick-track {
        display: flex;
        align-items: center;

        & > .slick-slide {
          display: flex;
          width: ${(props) => (props.isMobile ? '75px' : '85px')};
          height: ${(props) => (props.isMobile ? '75px' : '85px')};
          align-items: center;
          margin: 0 3.5px;
        }
      }
    }
  }
`;
